import { type AfterViewChecked, Component, HostListener, inject, type OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToasterComponent } from '@components/toaster/toaster.component';
import { LayoutService } from './core/layout.service';
import { LoadingOverlayComponent } from '@components/loading-overlay/loading-overlay.component';
import { environment } from 'src/environments/environment';
import { ToastService } from './core/toast.service';
import { InboxService } from './core/inbox.service';
import { ApiService } from './core/api.service';
import { CreditCheckDialogComponent } from "./dialogs/credit-check-dialog/credit-check-dialog.component";
import { UsageService } from './core/usage.service';
import { SwUpdate } from '@angular/service-worker';
import { version } from '../../package.json';
import { UpdateService } from './core/update.service';
import { filter, type Observable, take } from 'rxjs';
import { LoadingService } from './core/loading.service';
import { AsyncPipe } from '@angular/common';
import { SupabaseService } from './core/supabase.service';
import { SessionService } from './core/session.service';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet, ToasterComponent, LoadingOverlayComponent, ToasterComponent,
    CreditCheckDialogComponent, 
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, AfterViewChecked {
  title = 'NorthAI';
  layout = inject(LayoutService);
  toastService = inject(ToastService);
  inboxService = inject(InboxService);
  usageService = inject(UsageService);
  loadingService = inject(LoadingService);
  api = inject(ApiService);
  updateService = inject(UpdateService);
  supabase = inject(SupabaseService);
  sessionService = inject(SessionService);
  
  loading = signal(false);
  version = version;
  initialCheckDone$: Observable<boolean>;

  constructor() {
    this.initialCheckDone$ = this.updateService.initialCheckDone$;
  }

  ngOnInit() {
    this.loadingService.loadingOn('initial-update-check');
    this.updateService.performInitialUpdateCheck();
    this.initialCheckDone$.subscribe((done) => {
      console.log('initialCheckDone', done);
      this.loadingService.loadingOff('initial-update-check');
    });
    const sessionData = this.sessionService.sessionData();
    console.log('sessionData', sessionData);
  }

  ngAfterViewChecked() {
    this.layout.viewInit();
  }


}

